import { withChartLayout } from 'components/common';
import SensoryAssessment from 'components/features/chart/system-assessment/sensory-assessment/SensoryAssessment';

const SensoryAssessmentPage = withChartLayout('Sensory Assessment')(SensoryAssessment);
export default SensoryAssessmentPage;
